import React from 'react';
import { Router } from '@abyss/web/ui/Router';

export const Home = () => {
  return (
    <React.Fragment>
      <style>
        {`
        /* prototype structure code */
.protoWrap {
  max-width: 805px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 60px;
  margin-bottom: 60px;
}

/* recommendation card */
.card {
  position: relative;
  display: flex;
}

.card-flair {
  position: absolute;
  height: 4rem;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #002677;
  border-top-right-radius: 36px;
  border-top-left-radius: 36px;
}

.card-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .15);
  margin-top: 1rem;
}

.card-hd {
  padding: 1rem;
}

.card-bd {
  flex: 1;
  padding: 1rem;
  background-color: #EEF8FB;
}

.card-ft {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.flag {
  position: relative;
  margin-left: -1.75rem;
}

.flag-bar {
  clip-path: polygon(0px 0px, 100% 0px, calc(100% - 15px) 100%, 0% 100%);
  background-color: #d14600;
  padding-block: 0.5rem;
  padding-inline: 1.25rem;
  border-bottom-left-radius: 0.375rem;
  border-top-left-radius: 0.375rem;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.flag:before {
  content: '';
  width: 16px;
  height: 48px;
  background-image: url(./assets/images/flag.svg);
  background-position: top left;
  background-repeat: no-repeat;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
}

.card-title {
  margin-top: 13px;
}

.card-title a {
  color: #002677;
  font-family: "UHC2020 Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  text-decoration-line: underline;
  text-decoration-style: solid;
  line-height: 1.2;
}

.card-info {
  display: flex;
  gap: 48px;
  margin-bottom: 16px;
}

.card-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-data-hd {
  color: #4B4D4F;
  font-family: "UHC2020 Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.07;
}

.card-data-bd {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.06;
}

.card-button button {
  display: inline-flex;
  background: #d14600;
  border: 1px solid #d14600;
  height: 40px;
  padding: 0 20px;
  max-width: 168px;
  width: 100%;
  align-items: center;
  appearance: none;
  border-radius: 1.5rem;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  justify-content: center;
  line-height: 20px;
  position: relative;
  transition-duration: .25s;
  transition-property: background;
  transition-timing-function: cubic-bezier(.2,.8,.4,1);
  white-space: nowrap;
}

.card-button button:hover {
  background: #aa3600;
}

.card-ft button {
  display: inline-flex;
  align-items: center;
  color: #196ecf;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  appearance: none;
  border: 0;
  background: transparent;
}

.card-ft button:hover {
  text-decoration: underline;
}

/* CTA Card */
.cta-card {
  width: 100%;
  border-radius: 24px;
  border: 1px solid #CBCCCD;
  background: #F7FCFD;
  padding: 26px 20px;
}

.cta-card-hd {
  margin-bottom: 20px;
}

.cta-title {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

.cta-card-ft {
  margin-top: 24px;
}

.alt-button {
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid #002677;
  background: #fff;
  color: #002677;
  text-align: center;
  font-family: "UHC2020 Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
  
.logos {
margin: 60px auto;
max-width: 400px;
}

.logos > * + * {
margin-top: 40px;}
`}
      </style>
      <Router.MetaTags title="Home" />
      <div>
        {/* <div className="card">
          <div className="card-flair"></div>
          <div className="card-inner">
            <div className="card-hd">
              <div className="flag">
                <div className="flag-bar">
                  <span className="flag-copy">#1 Recommendation</span>
                </div>
              </div>
              <div className="card-title">
                <a href="#">
                  AARP Medicare Advantage from UHC GA-0006 (HMO-POS)
                </a>
              </div>
            </div>
            <div className="card-bd">
              <div className="card-info">
                <div className="card-data">
                  <div className="card-data-hd">Monthly premium</div>
                  <div className="card-data-bd">$0</div>
                </div>
                <div className="card-data">
                  <div className="card-data-hd">Out-of-pocket maximum</div>
                  <div className="card-data-bd">$5,900</div>
                </div>
              </div>
              <div className="card-button">
                <button type="button">Enroll in plan</button>
              </div>
            </div>
            <div className="card-ft">
              <button type="button">
                <span>View plan details</span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M8.58997 16.59L13.17 12L8.58997 7.41L9.99997 6L16 12L9.99997 18L8.58997 16.59Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="cta-card">
          <div className="cta-card-hd">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
            >
              <g clip-path="url(#clip0_3402_3166)">
                <path
                  d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
                  fill="#002677"
                />
                <path
                  d="M31.9999 10.667L38.0666 22.947L51.6133 24.9203L41.7999 34.4803L44.1199 47.9736L31.9999 41.6003L19.8799 47.9736L22.1999 34.4803L12.3866 24.9203L25.9333 22.947L31.9999 10.667Z"
                  fill="white"
                />
                <path
                  d="M32 46.6667C30.8933 46.6667 30 47.56 30 48.6667V57.3333L34 56V48.6667C34 47.56 33.1067 46.6667 32 46.6667ZM56.12 37.0267L49.1467 34.76C48.0933 34.4133 46.9733 34.9867 46.6267 36.04C46.28 37.0933 46.8667 38.2133 47.9067 38.56L56.1467 41.24L56.12 37.0267ZM44.9067 10.12L40.6 16.0533C40.445 16.2661 40.3335 16.5073 40.2718 16.7631C40.21 17.019 40.1993 17.2845 40.2401 17.5445C40.281 17.8045 40.3726 18.0539 40.5099 18.2785C40.6471 18.503 40.8273 18.6984 41.04 18.8533C41.4697 19.1663 42.006 19.2958 42.5311 19.2132C43.0562 19.1307 43.5271 18.843 43.84 18.4133L48.9333 11.4L44.9067 10.12ZM18.3067 9.04001L15.8533 12.4667L20.16 18.4C20.8133 19.2933 22.0533 19.4933 22.96 18.84C23.8667 18.1867 24.0533 16.9467 23.4 16.04L18.3067 9.04001ZM14.8533 34.76L6.61334 37.44L9.12001 40.8267L16.0933 38.56C17.1467 38.2133 17.72 37.0933 17.3733 36.04C17.0267 34.9867 15.9067 34.4133 14.8533 34.76Z"
                  fill="#00BED5"
                />
              </g>
              <defs>
                <clipPath id="clip0_3402_3166">
                  <rect width="64" height="64" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="cta-card-bd">
            <div className="cta-title">More recommended plans available</div>
            <div className="cta-copy">
              <p>
                Since you have completed the plan recommendation questions, we
                have 5 ranked results for you based on your specific needs.
              </p>
            </div>
          </div>
          <div className="cta-card-ft">
            <button type="button" className="alt-button">
              View all of your results
            </button>
          </div>
        </div> */}
        <div className="logos">
          <div>
            <img src="/assets/images/logo1.png" alt="logo1" />
          </div>
          <div>
            <img src="/assets/images/logo2.png" alt="logo2" />
          </div>
          <div>
            <img src="/assets/images/logo3.png" alt="logo3" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
